export const nextDOMUpdate = (container: HTMLElement) =>
  new Promise(resolve => {
    const observer = new MutationObserver(() => {
      observer.disconnect();
      resolve(null);
    });
    setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, 1000);
    observer.observe(container, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  });
